import { render } from "./PriceListPage.vue?vue&type=template&id=5da7cec1&scoped=true"
import script from "./PriceListPage.vue?vue&type=script&lang=js"
export * from "./PriceListPage.vue?vue&type=script&lang=js"

import "./PriceListPage.vue?vue&type=style&index=0&id=5da7cec1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da7cec1"]])

export default __exports__